import { NumberInput } from '@components/NumberInput';
import { DollarSignIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/MinRateGroup.styled';
import { TitleGroup } from './TitleGroup';

export const MinRateGroup: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    return (
        <styled.MinRateGroup>
            <TitleGroup
                title="Minimum rate requirements"
                Icon={DollarSignIcon}
                Chip={<Chip label="optional" variant="caution" />}
            />
            <div>
                If the owner has a minimum price requirement, please indicate the minimum nightly
                rate for the year.
            </div>
            <styled.Wrapper>
                <NumberInput disabled={disabled} name="min_rate" decimals={2} prefix="$ " />
            </styled.Wrapper>
        </styled.MinRateGroup>
    );
};
